import { EmeraldAppHeader } from "@emerald-react/app-header";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";
import UserMenu from "./UserMenu";

const AppLayout = () => {
  const [toggleHeader, setToggleHeader] = useState(true);
  const [animationClass, setAnimationClass] = useState<string>("slideInDown");
  const [hideConfigMenu, setHideConfigMenu] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Check if URL contains "innerapp" to hide header completely
  const isInnerApp = location.pathname.includes("innerapp");

  useEffect(() => {
    const storedHeaderState = localStorage.getItem("showAppShell");
    if (storedHeaderState) {
      setToggleHeader(storedHeaderState === "true");
    }

    // Check if config menu should be hidden
    const hideConfigValue = localStorage.getItem("hideConfigMenu");
    setHideConfigMenu(hideConfigValue === "true");
  }, []);

  return (
    // overflow-y-auto should only be applied when the url or location.pathname is "/"
    <main
      className={classNames("not-print:h-screen not-print:max-h-screen", {
        "overflow-y-auto":
          location.pathname === "/" || location.pathname.includes("/preview/"),
        "inner-app-header": isInnerApp,
      })}
    >
      {!isInnerApp && (
        <>
          {toggleHeader ? (
            <EmeraldAppHeader
              logo={
                <div tabIndex={0} onClick={() => navigate("/")}>
                  CBRE ONE
                </div>
              }
              customItems={[
                ...(hideConfigMenu
                  ? []
                  : [
                      <UserMenu
                        key="user-menu"
                        setToggleHeader={setToggleHeader}
                        toggleHeader={toggleHeader}
                        setAnimationClass={setAnimationClass}
                      />,
                    ]),
              ]}
              type="light"
              className={classNames(
                "sticky-app-header animated",
                animationClass,
              )}
            />
          ) : (
            !hideConfigMenu && (
              <UserMenu
                setToggleHeader={setToggleHeader}
                toggleHeader={toggleHeader}
                setAnimationClass={setAnimationClass}
              />
            )
          )}
        </>
      )}
      <Outlet />
    </main>
  );
};

export default AppLayout;
